import React from "react";
import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/solid";
import { LazyLoadedImage } from "@reusejs/react";
import { useRouter } from "next/router";
import { ImageSliderComponent } from "./ImageSliderComponent";

export default function ImageSlider(props: any) {
  const router = useRouter();
  const List = [
    // <div
    //   key={"slider-image-1"}
    //   className="px-4 py-8 xl:px-0 max-w-screen-xl m-auto"
    // >
    //   <div
    //     className="w-full relative object-cover rounded-md overflow-hidden select-none cursor-pointer"
    //     onClick={() =>
    //       router.push("/auction-properties-by-centbank-home-finance-limited")
    //     }
    //   >
    //     <img
    //       className="object-cover rounded-md"
    //       src={`${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/1b213715-aaf9-4343-ab6e-93ad6a4b273c?fit=fill&auto=format`}
    //       alt="bank auction properties"
    //     />
    //   </div>
    // </div>,
    // <div
    //   key={"slider-image-1"}
    //   className="px-4 py-8 xl:px-0 max-w-screen-xl m-auto"
    // >
    //   <div
    //     className="w-full relative object-cover rounded-md overflow-hidden select-none cursor-pointer"
    //     onClick={() =>
    //       router.push("/auction-properties-by-muthoot-homefin-india-ltd")
    //     }
    //   >
    //     <img
    //       className="object-cover rounded-md"
    //       src={`${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/a2981c0d-e9a0-45f7-a344-65a1712cdca7?fit=fill&auto=format`}
    //       alt="bank auction properties"
    //     />
    //   </div>
    // </div>,
    // <div
    //   key={"slider-image-1"}
    //   className="px-4 py-8 xl:px-0 max-w-screen-xl m-auto"
    // >
    //   <div
    //     className="w-full relative object-cover rounded-md overflow-hidden select-none cursor-pointer"
    //     // onClick={() =>
    //     //   router.push("/auction-properties-by-muthoot-homefin-india-ltd")
    //     // }
    //   >
    //     <img
    //       className="object-cover rounded-md"
    //       src={`${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/957d8b0a-fdea-48a4-9bc0-33979cb50507?fit=fill&auto=format`}
    //       alt="bank auction properties"
    //     />
    //   </div>
    // </div>,
    // <div
    //   key={"slider-image-1"}
    //   className="px-4 py-8 xl:px-0 max-w-screen-xl m-auto"
    // >
    //   <div
    //     className="w-full relative object-cover rounded-md overflow-hidden select-none cursor-pointer"
    //     // onClick={() =>
    //     //   router.push("/auction-properties-by-muthoot-homefin-india-ltd")
    //     // }
    //   >
    //     <img
    //       className="object-cover rounded-md"
    //       src={`${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/6e0dc191-1130-456d-bd44-057eda20a713?fit=fill&auto=format`}
    //       alt="bank auction properties"
    //     />
    //   </div>
    // </div>,
    // <div
    //   key={"slider-image-1"}
    //   className="px-4 py-8 xl:px-0 max-w-screen-xl m-auto"
    // >
    //   <div
    //     className="w-full relative object-cover rounded-md overflow-hidden select-none cursor-pointer"
    //     // onClick={() =>
    //     //   router.push("/auction-properties-by-muthoot-homefin-india-ltd")
    //     // }
    //   >
    //     <img
    //       className="object-cover rounded-md"
    //       src={`${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/9e6c5959-310b-4965-883b-c22b3466a7db?fit=fill&auto=format`}
    //       alt="bank auction properties"
    //     />
    //   </div>
    // </div>,
    <div
      key={"slider-image-1"}
      className="px-4 py-8 xl:px-0 max-w-screen-xl m-auto"
    >
      <div className="w-full relative object-cover rounded-md overflow-hidden select-none">
        <img
          className="object-cover rounded-md"
          src="/propertyOne.png"
          alt="bank auction properties"
        />
      </div>
    </div>,
  ];

  const list = props?.allBanner?.map((banner: any, index: number) => {
    return (
      <div
        key={`slider-image-${index}`}
        className="px-4 py-8 xl:px-0 w-full m-auto"
      >
        <div className="w-full relative object-cover rounded-md overflow-hidden select-none">
          <img
            className="w-full object-cover rounded-md"
            src={
              banner.attributes?.image?.data?.attributes?.formats?.large?.url
            }
            alt="bank auction properties"
          />
        </div>
      </div>
    );
  });
  return (
    <div className="flex justify-center">
      <ImageSliderComponent elements={list?.length > 0 ? list : List} />
    </div>
  );
}
